import React from 'react';

interface OwnProps {
  title: string;
  informations: { key: string; value: string }[];
}

const PlanInfoColumnBase = ({ title, informations = [] }: OwnProps) => {
  const planInfoKeyList = informations.map(info => {
    const { key, value } = info;
    return (
      <div key={key}>
        <div className="flex flex-col">
          <p className="text-sm font-bold">{value}</p>
          <p className="text-neutral-500 text-xs">{key.toUpperCase()}</p>
        </div>
      </div>
    );
  });

  return (
    <div className="flex flex-col gap-3">
      {title && <p className="text-sm font-bold text-blue-500">{title}</p>}
      <div className="list gap-3 items-start">{planInfoKeyList}</div>
    </div>
  );
};

export default PlanInfoColumnBase;
